import { Suspense, useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import BountifulHero from './components/BountifulHero';
import BountifulTrust from './components/BountifulTrust';
import BountifulServices from './components/BountifulServices';
import BountifulNeighborhoods from './components/BountifulNeighborhoods';
import BountifulTestimonial from './components/BountifulTestimonial';
import BountifulContact from './components/BountifulContact';

export default function BountifulPage() {
  useEffect(() => {
    window.scrollTo(0, 0);

    document.title = 'Water Damage Restoration Bountiful Utah | 24/7 Emergency Flood Cleanup Services';

    const metaTags = [
      { name: 'description', content: 'Expert water damage restoration in Bountiful, Utah. 24/7 emergency flood cleanup, mold remediation, and fire damage repair near Mueller Park & Val Verda. Fast response, certified professionals. Call (385) 340-6632 for immediate assistance.' },
      { name: 'keywords', content: 'water damage restoration Bountiful, flood cleanup Bountiful Utah, emergency water removal Bountiful, mold remediation Bountiful, fire damage repair Bountiful' },
      { name: 'geo.position', content: '40.8894;-111.8808' },
      { name: 'geo.region', content: 'US-UT' },
      { name: 'geo.placename', content: 'Bountiful, Utah' },
      { property: 'og:title', content: 'Water Damage Restoration Bountiful Utah | Davis County Disaster Cleanup' },
      { property: 'og:description', content: '24/7 emergency water damage restoration in Bountiful. Expert flood cleanup, mold removal, and disaster recovery services.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://daviscountydisastercleanup.com/bountiful' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Water Damage Restoration Bountiful Utah | Davis County Disaster Cleanup' },
      { name: 'twitter:description', content: '24/7 emergency water damage restoration in Bountiful. Expert flood cleanup and disaster recovery.' }
    ];

    metaTags.forEach(({ name, property, content }) => {
      const attr = name ? 'name' : 'property';
      const value = name || property;
      let meta = document.querySelector(`meta[${attr}="${value}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, value as string);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content as string);
    });

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://daviscountydisastercleanup.com/bountiful');

    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Do you provide 24/7 emergency water damage restoration in Bountiful?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Davis County Disaster Cleanup provides 24/7 emergency water damage restoration services throughout Bountiful, Utah. We respond immediately to water emergencies near Mueller Park, Val Verda, Bountiful Heights, and all Bountiful neighborhoods."
          }
        },
        {
          "@type": "Question",
          "name": "How quickly can you respond to water damage in Bountiful?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We typically arrive within 60 minutes for emergency water damage calls in Bountiful. Our local team knows the area well, from Mueller Park Canyon to Historic Main Street, ensuring rapid response times."
          }
        },
        {
          "@type": "Question",
          "name": "What areas of Bountiful do you serve?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We serve all of Bountiful including Val Verda, Bountiful Heights, Mueller Park, Orchard Hills, South Bountiful, and Historic Main Street. No location in Bountiful is too far for our emergency response team."
          }
        }
      ]
    };

    let script = document.querySelector('script[data-schema="bountiful-faq"]');
    if (!script) {
      script = document.createElement('script');
      script.setAttribute('type', 'application/ld+json');
      script.setAttribute('data-schema', 'bountiful-faq');
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(faqSchema);

    return () => {
      const schemaScript = document.querySelector('script[data-schema="bountiful-faq"]');
      if (schemaScript) schemaScript.remove();
    };
  }, []);

  return (
    <Suspense fallback={<div className="min-h-screen bg-white"></div>}>
      <div className="min-h-screen bg-white">
        <Navbar />
        <BountifulHero />
        <BountifulTrust />
        <BountifulServices />
        <BountifulNeighborhoods />
        <BountifulTestimonial />
        <BountifulContact />
        <Footer />
      </div>
    </Suspense>
  );
}
